import React from 'react'

export const MiniLoader = () => {
  return (
    <div className="text-center">
      <img src="/images/ajax-loader.gif" />
    </div>
  )
}
